<template>
  <div class="simple-media-component">
    <media-player v-if="isAudio" ref="player" :media="audioData" />
    <img v-if="isImage" :src="mediaData.mediaUrl" class="thumbnail" alt="" />
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, ref } from "vue";
import { MEDIA_TYPE } from "@plugins/media/media.constant";

const MediaPlayer = defineAsyncComponent(() => import("@plugins/media/components/MediaPlayer.vue"));

interface SimpleMediaData {
  mediaType: (typeof MEDIA_TYPE)[keyof typeof MEDIA_TYPE];
  mediaUrl: string;
}

const props = defineProps<{ mediaData: SimpleMediaData }>();

const player = ref<unknown>();

const isImage = computed<boolean>(() => props.mediaData.mediaType === MEDIA_TYPE.IMAGE);
const isAudio = computed<boolean>(() => props.mediaData.mediaType === MEDIA_TYPE.AUDIO);

interface AudioData {
  src: string;
  audioOnly: boolean;
}

const audioData = computed<AudioData>(() => ({
  src: props.mediaData.mediaUrl,
  audioOnly: true,
}));
</script>
